'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';

import styles from './TimelineIcon.module.scss';

type ContainerProps = BaseComponentProps & {
  icon: ReactNode;
  direction?: 'vertical' | 'horizontal';
  last?: boolean;
};

function TimelineIcon({
  style,
  className,
  icon,
  direction,
  last = false,
  testId = 'ui-timeline-icon',
}: ContainerProps) {
  return (
    <div
      style={style}
      className={classnames(
        styles['main'],
        direction && styles[`main--${direction}`],
        className,
      )}
      data-testid={testId}
    >
      {icon}
      {!last ? (
        <div
          className={classnames(
            styles['line'],
            direction && styles[`line--${direction}`],
          )}
        />
      ) : null}
    </div>
  );
}

export { TimelineIcon };
